// client/src/features/buildings/search.ts — SCR-BLD-002's URL state · D-3361 (04 §9.2.3).
//
// One route, and the tabs are a search param rather than child routes — the shape „Chiriaș la
// rândul meu" took (D-1190): a tab is shareable, survives a refresh, and Back undoes it. A tab the
// URL names that is not one of the six falls back to „Apartamente" rather than failing the route.

import { z } from 'zod';

import { BUILDING_TABS, type BuildingTab } from './enums';

export const buildingSearchSchema = z.object({
  tab: z.enum(BUILDING_TABS).optional().catch(undefined),
  // Lane 4 · tickets — the ticket the „Tichete" tab's drawer shows, so a notification's link
  // („/app/buildings/<id>?tab=tickets&ticket=<id>", D-3389) opens it and Back closes it.
  ticket: z.string().optional().catch(undefined),
  // The staircase and floor „Apartamente", „Locatari", „Contoare" and „Citiri" show (D-3430,
  // D-3460); `resolveScope` falls back to the first staircase and the lowest floor.
  stair: z.string().optional().catch(undefined),
  floor: z.coerce.number().int().optional().catch(undefined),
});

export type BuildingSearch = z.infer<typeof buildingSearchSchema>;

/** The tab the profile shows: the URL's, or „Apartamente" when it names none. */
export function activeBuildingTab(search: BuildingSearch): BuildingTab {
  return search.tab ?? 'apartments';
}
